import {countriesExportingOrImporting} from './common/countries-exporting-or-importing';

/**
 * Survey: PROJECT - FINAL IMPACT
 * Question: Please specify from which Countries
 * 
 * == final
 * question1
 * 
 * @param props 
 * @returns 
 */
export const countriesImportingChartCalculation = (props: any) => {
    return countriesExportingOrImporting(props, 'question1', 'Countries Importing');
}